import getSplashApiClientV2 from 'lib/SplashApiClient/singletonV2';

/**
 * API client for Do Not Sell settings related endpoints
 */
export default class DoNotSellApiClient {
    /**
     * @param {SplashApiClient} apiClient
     */
    constructor(apiClient) {
        this.apiClient = apiClient;
    }

    /**
     * Get do not sell settings collection
     * Returns array — empty, one (org), or two (org + event) items
     * @param {Object} params
     * @param {string} params.organizationId
     * @param {string} params.eventId
     * @returns {Promise<unknown>}
     */
    getDonsSettings({ organizationId, eventId } = {}) {
        const params = { organizationId };
        if (eventId) params.eventId = eventId;
        return this.apiClient.get('/do-not-sell-settings', params);
    }

    /**
     * Create a new do not sell settings record (first save — org or event level)
     * @param {Object} payload
     * @returns {Promise<unknown>}
     */
    createDonsSettings(payload) {
        return this.apiClient.post('/do-not-sell-settings', payload);
    }

    /**
     * Update an existing do not sell settings record by id
     * @param {string} id
     * @param {Object} payload
     * @returns {Promise<unknown>}
     */
    updateDonsSettings(id, payload) {
        return this.apiClient.put(`/do-not-sell-settings/${id}`, payload);
    }

    /**
     * Delete a do not sell settings record by id (used to reset event-level settings)
     * @param {string} id
     * @returns {Promise<unknown>}
     */
    deleteDonsSettings(id) {
        return this.apiClient.delete(`/do-not-sell-settings/${id}`);
    }

    /**
     * Submit guest do not sell consent (public endpoint)
     *
     * @param eventId
     * @param payload
     * @returns {Promise<unknown>}
     */
    submitEventDoNotSellConsent({ eventId, payload }) {
        return this.apiClient.post(`/public/events/${eventId}/do-not-sell-consents`, payload, {
            omitAccessToken: true,
        });
    }
}

export const getDoNotSellApiClient = () => new DoNotSellApiClient(getSplashApiClientV2());
